<template>
  <div>
  <div
    :class="[unauthorizedWinnerInfo.gameType === 'MW' ? 'modal modal-game_memory_wizard' : unauthorizedWinnerInfo.gameType === 'ODD' ? 'modal modal-game_odd_object alternative_flow_odd_modal': 'modal modal-game_spot_difference']"
    :id="[unauthorizedWinnerInfo.gameType === 'MW' ? 'modal-game_memory_wizard' : unauthorizedWinnerInfo.gameType === 'ODD' ? 'modal-game_odd_object': 'modal-game_spot_difference']">
    <div class="modal__content won_game_modal">
      <button class="btn modal-close"><i class="icon-close"></i></button>
      <div class="modal__header modal_ti_header">
        <div class="row gamepage_header">
          <img v-if="unauthorizedWinnerInfo.gameType === 'MW'" class="gamepage_logo " src="static/images/logo-memory-wizard.png"/>
          <img v-if="unauthorizedWinnerInfo.gameType === 'ODD'" class="gamepage_logo " src="static/images/logo-odd-object.png"/>
          <img v-if="unauthorizedWinnerInfo.gameType === 'SD'" class="gamepage_logo " src="static/images/logo-spot-difference.png"/>
          <h1 v-if="unauthorizedWinnerInfo.gameType === 'MW'">{{ getTranslations.home_game_memory_wizard }}</h1>
          <h1 v-if="unauthorizedWinnerInfo.gameType === 'ODD'">{{ getTranslations.home_game_odd_game }}</h1>
          <h1 v-if="unauthorizedWinnerInfo.gameType === 'SD'">{{ getTranslations.home_game_sd_game }}</h1>
          <p>{{ getTranslations.home_alternative_prize_congratulations }}</p>
          <p class="cta_support">{{ getTranslations.home_alternative_prize_you_successfully }}</p>
        </div>
      </div>
      <div class="modal__body">
        <h1 class="prize_won_headline">{{ unauthorizedWinnerInfo.name }}</h1>
        <div class="prize_won_image prize_won_image_prize">
          <img :src="unauthorizedWinnerInfo.imageWonUrl" />
          <div class="prize_won_image prize_won_image_conffeti"></div>
        </div>
        <p class="cta_support">{{ getTranslations.home_alternative_prize_congratulations_we_will }}.</p>
      </div>
    </div>
  </div>
  <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'prize-for-free-game',
  computed: {
    ...mapState('game', [
      'unauthorizedWinnerInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/PrizeForFreeGame.vue